import React from "react";
import { Users, Tally3, Target, Bell, Search, TrendingUp, UserCheck, ClipboardCheck } from "lucide-react";

const CoachMainDocs = () => {
  return (
    <div className="space-y-12 pb-20">
      {/* Header */}
      <section>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 border border-blue-100 mb-4">
          <UserCheck size={14} className="text-blue-600" />
          <span className="text-[10px] font-black text-blue-600 uppercase tracking-widest">Coach Command</span>
        </div>
        <h1 className="text-4xl font-black text-gray-900 tracking-tight mb-4">Roster Management</h1>
        <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
          The Coach Dashboard is your hub for evaluating talent. Monitor your athletes' progress, set program benchmarks, 
          and identify the "Gaps to Goal" that define your next training cycle.
        </p>
      </section>

      {/* Primary Features */}
      <div className="grid md:grid-cols-2 gap-6">
        {/* Roster Card */}
        <div className="bg-white border border-gray-100 p-8 rounded-3xl shadow-sm space-y-4">
          <div className="bg-green-100 w-12 h-12 rounded-2xl flex items-center justify-center text-green-600">
            <Users size={24} />
          </div>
          <h3 className="text-xl font-bold text-gray-900">Live Roster Oversight</h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            View every athlete who follows your program. Track their onboarding status and see who has 
            submitted their latest combine scores in real-time.
          </p>
        </div>

        {/* Benchmarks Card */}
        <div className="bg-white border border-gray-100 p-8 rounded-3xl shadow-sm space-y-4">
          <div className="bg-blue-100 w-12 h-12 rounded-2xl flex items-center justify-center text-blue-600">
            <Target size={24} />
          </div>
          <h3 className="text-xl font-bold text-gray-900">Program Benchmarks</h3>
          <p className="text-sm text-gray-500 leading-relaxed">
            Define what "Elite" looks like for your team. Set target times and scores for every position 
            to give your athletes a clear standard to chase.
          </p>
        </div>
      </div>

      

      {/* Analytics Section */}
      <section className="bg-slate-900 rounded-3xl p-8 text-white">
        <div className="flex flex-col md:flex-row gap-8 items-center">
          <div className="flex-1 space-y-4">
            <div className="flex items-center gap-2">
              <TrendingUp className="text-blue-400" />
              <h3 className="text-2xl font-bold">Gap Analysis</h3>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Nuvio automatically calculates the difference between an athlete's current score and 
              your set benchmark. This allows you to group athletes by training needs instantly.
            </p>
          </div>
          <div className="w-full md:w-64 bg-slate-800 p-4 rounded-xl border border-slate-700">
             <div className="flex justify-between text-[10px] mb-2 font-bold uppercase tracking-widest text-slate-400">
                <span>Athlete Gap</span>
                <span className="text-red-400">-0.4s</span>
             </div>
             <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
                <div className="h-full bg-blue-500 w-[60%]"></div>
             </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CoachMainDocs;